import type { Bytes } from "@pdfking/structs"

import { INTEGRITY_LENGTH, IntegrityLine } from "../internal/StreamFormat"

/** What goes in front of a merge output `size` bytes long: the integrity
 * line, recording the whole file's length so a reader can tell the file is
 * still exactly what the merge wrote (see StreamFormat). The merge already
 * left room for it, so the two are one pdf. */
export const PDFMergeIntegrity = (size: Bytes): string => IntegrityLine(size + INTEGRITY_LENGTH)
